import React from 'react';
import Icon from './Icon';

export default Icon(
  <g>
    <circle
      cx="8"
      cy="8"
      r="8"
    />
    <g transform="translate(-3 -4)">
      <path fill="white" d="M5.6,4H7.2V5.6H5.6Zm0,3.2H7.2V12H5.6Z" transform="translate(4.6 8) rotate(180 6.5 6)" />
    </g>
  </g>,
  '0 0 16 16',
  'BadgeWarningIcon',
);
